import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { createGradientOrSolid } from 'utils/index';
import { Gradient } from 'utils/types';

export const StyledCashFrenzy = styled.div<{
  backgroundSrc?: string;
  backgroundColor: Gradient;
  inMobileMock: boolean;
  crossIcon?: string;
}>`
  width: 100%;
  min-height: 160px;
  height: 160px;
  max-width: 343px;
  border-radius: 8px;
  font-family: var(--font-family), Arial;
  background: ${({ backgroundSrc, backgroundColor }) =>
    backgroundSrc
      ? `url("${backgroundSrc}")`
      : createGradientOrSolid(backgroundColor)};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  &:last-child {
    margin-bottom: 0 !important;
  }

  .container {
    width: 100%;
    height: 100%;
    padding: 14px 14px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .emblem {
      position: absolute;
      top: 0px;
      right: 0px;
      min-width: 50px;
      min-height: 43px;
      width: 50px;
      height: 43px;
      z-index: 1;

      &-badge {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .products {
      display: flex;
      justify-content: space-around;
      width: 100%;

      &-main {
        min-width: 88px;
        min-height: 88px;
        width: 88px;
        height: 88px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        margin-top: 13px;

        .image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      &-info {
        display: flex;
        flex-direction: column;
        width: max-content;
        width: 210px;
        justify-content: center;

        &__stroked {
          margin: 0 auto 4px;
          padding: 0 16px;
          justify-content: center;
          width: 210px;

          .stroked {
            width: 100%;
            text-align: center;
            font-style: normal;
            font-weight: 600;
            color: #6b2102;
            line-height: 12px;
            text-decoration: line-through;
            text-decoration-color: #fd1616;
            font-size: calc(clamp(4px, 1em * 0.75, 12px));
          }
        }

        .products-container {
          width: 210px;
          display: flex;
          align-items: center;
          padding: 6px 8px;
          background-color: #802607;
          border-radius: 16px;
          max-width: max-content;
          margin: 0 auto;
          min-width: 210px;
          justify-content: center;
          flex-direction: column;

          &__quantity {
            text-align: center;
            text-shadow: 1px 1px 1px #731c0a, -1px -1px 1px #731c0a,
              1px -1px 1px #731c0a, -1px 1px 1px #731c0a;
            font-style: normal;
            font-weight: 850;
            font-size: calc(clamp(4px, 1em * 1.17, 14px));
            line-height: 18px;
            color: #fee810;
            text-align: center;
            width: 100%;
          }

          .sub-products {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 4px;
            width: 100%;

            &__container {
              position: relative;
              padding-left: 6px;
              padding-right: 6px;

              &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 0.5px;
                height: 70%;
                background-color: #fcd104;
                border-radius: 100%;
              }

              &:first-child {
                &::before {
                  display: none;
                }
                padding-left: 0;
              }

              &:last-child {
                padding-right: 0;
              }

              &-item {
                width: 32px;
                height: 32px;
                position: relative;
                background-color: #9b3f0a;
                border-radius: 4px;
                padding: 2px 4px;
                display: flex;
                align-items: center !important;
                justify-content: center;

                .image {
                  width: 23px;
                  height: 23px;
                  object-fit: contain;
                }

                .quantity {
                  padding: 0 4px;
                  bottom: 2px;
                  line-height: 12px;
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  font-weight: 850;
                  text-transform: capitalize;
                  text-align: center;
                  text-shadow: 0.5px 0.5px 0.5px #731c0a,
                    -0.5px -0.5px 0.5px #731c0a, 0.5px -0.5px 0.5px #731c0a,
                    -0.5px 0.5px 0.5px #731c0a;
                  font-size: calc(clamp(4px, 1em * 0.75, 12px));
                }
              }
            }

            &__tooltip {
              width: 20px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              padding-left: 6px;

              &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 0.5px;
                height: 70%;
                background-color: #fcd104;
                border-radius: 100%;
              }

              .icon {
                min-width: 12px;
                min-height: 12px;
                width: 12px;
                height: 12px;
                object-fit: contain;
              }
            }

            .tooltip-content {
              position: absolute;
              top: 50%;
              right: 42px;
              transform: translateY(-50%);
              width: 128px;
              background-color: #b24603;
              border: 1px solid #fff;
              text-align: center;
              font-size: 8px;
              font-style: normal;
              font-weight: 800;
              line-height: 8px;
              letter-spacing: 0.8px;
              color: #fff;
              border-radius: 2px;
              padding: 2px;
            }
          }
        }

        .timer {
          font-size: 12px;
          font-style: normal;
          font-weight: 800;
          line-height: 12px;
          letter-spacing: 0.48px;
          color: #fff;
          text-align: center;
          margin: 4px auto 0;
        }
      }
    }

    .price {
      background: var(--button-bg-color);
      height: 32px;
      max-width: 240px;
      margin: auto auto 0;
      border-radius: 8px;
      box-shadow: 0 -2px 1px 0 #035f01 inset, 0 4px 2px 0 #92fb03 inset,
        0 2px 1px 0 #edfe33 inset, 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      padding: 0 15px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 4px;
        width: 23px;
        height: 27px;
        background-image: url(${({ crossIcon }) => crossIcon});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 10;
      }

      .totalPrice {
        width: calc(100% - 20px);
        align-items: center;

        .final-price,
        .isFree {
          align-items: center;
          text-shadow: 1px 1px 1px #074106, -1px -1px 1px #074106,
            1px -1px 1px #074106, -1px 1px 1px #074106;
          font-weight: 850;
          font-size: calc(clamp(4px, 1em * 1.17, 14px));

          .offer-button-asset-container {
            display: flex;
            align-items: center;
            height: 25px;
            margin-left: 4px;
            width: auto;

            .offer-button-asset {
              height: 25px;
              width: auto;
              object-fit: contain;
              margin-left: 4px;
            }
          }
        }
      }
    }
  }

  ${({ inMobileMock }) =>
    !inMobileMock &&
    `
  @media (min-width: ${breakpoints.desktop}) {
    min-height: 204px;
    max-width: 428px;
    height: 204px;
    border-radius: 10px;

    .container {
      padding: 18px 18px 14px;

      .emblem {
        min-width: 64px;
        min-height: 56px;
        width: 64px;
        height: 56px;
      }

      .products {
        &-main {
          min-width: 112px;
          min-height: 112px;
          width: 112px;
          height: 112px;
          margin-right: 8px;
        }

        &-info {
          width: 268px;

          &__stroked {
            padding: 0 22px;
            width: 268px;

            .stroked {
              line-height: 16px;
              font-size: calc(clamp(4px, 1em * 1.33, 16px));
            }
          }

          .products-container {
            width: 268px;
            border-radius: 20px;
            padding: 8px 10px;

            &__quantity {
              font-size: calc(clamp(4px, 1em * 1.5, 18px));
              line-height: 22px;
            }

            .sub-products {
              margin-top: 5px;

              &__container {
                padding-left: 8px;
                padding-right: 8px;

                &-item {
                  width: 40px;
                  height: 40px;
                  padding: 2px 6px;
                  border-radius: 6px;

                  .image {
                    width: 28px;
                    height: 28px;
                  }

                  .quantity {
                    padding: 0;
                    font-size: calc(clamp(4px, 1em * 1.17, 14px));
                    line-height: 14px;
                  }
                }
              }

              &__tooltip {
                width: 24px;
                height: 40px;
                padding-left: 8px;

                .icon {
                  min-width: 16px;
                  min-height: 16px;
                  width: 16px;
                  height: 16px;
                }
              }

              .tooltip-content {
                font-size: 10px;
                line-height: 10px;
                width: 165px;
                letter-spacing: 1px;
                padding: 4px;
                border-radius: 3px;
                right: 35px;
              }
            }
          }

          .timer {
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 0.56px;
            margin-top: 5px;
          }
        }
      }

      .price {
        height: 40px;
        max-width: 336px;
        border-radius: 10px;

        &::before {
          width: 30px;
          height: 35px;
        }

        .totalPrice {
          .final-price, .isFree {
            font-size: calc(clamp(4px, 1em * 1.5, 18px));

            .offer-button-asset-container {
              height: 30px;

              .offer-button-asset {
                height: 30px;
              }
            }
          }
        }
      }
    }
  }
  `}
`;
